import { render, staticRenderFns } from "./InitialEstimatedRate.vue?vue&type=template&id=37d38079&scoped=true"
import script from "./InitialEstimatedRate.vue?vue&type=script&lang=js"
export * from "./InitialEstimatedRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d38079",
  null
  
)

export default component.exports